import "core-js/modules/es6.object.assign";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { recursiveMenu, deepcopy } from '@/libs/util';
import { getgroup_permission } from '@/api/auth';
export default {
  name: "addAccoutAuth",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      currCode: null,
      //当前code
      currSelectList: {},
      //当前所选的列
      apilist: [],
      //所属于的接口
      indeterminate: true,
      checkAll: false,
      checkAllGroup: [],
      //选中的项
      currInterFace: [],
      //当前选中的接口列表
      showInterFace: false,
      personMenuData: [],
      reqBase: {
        page: 1,
        page_size: 100
      },
      spinShow: false,
      interConfit: [],
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      formModel: {
        admin_name: null,
        admin_real_name: null,
        menu_config: [],
        group_name: null
      },
      formRules: {}
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    personMenu: {},
    admin_id: {}
  },
  components: {},
  computed: {},
  methods: {
    handleCheckAll: function handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }

      this.indeterminate = false;

      if (this.checkAll) {
        var _this$checkAllGroup;

        var arr = [];

        for (var i in this.apilist) {
          var list = this.apilist[i];

          if (list.api_code) {
            arr.push(list.api_code);
          }
        }

        (_this$checkAllGroup = this.checkAllGroup).push.apply(_this$checkAllGroup, arr);
      } else {
        this.checkAllGroup.splice(0);
      }
    },
    checkAllGroupChange: function checkAllGroupChange(data) {
      var len = 0;

      for (var i in this.apilist) {
        if (this.apilist) {
          len++;
        }
      }

      if (data.length === len) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }

      this.checkAllGroup = data;
    },
    showModal: function showModal(b) {
      this.showInterFace = b;
    },

    /**
     *初始化接口配置
     */
    initInterFace: function initInterFace() {},
    //接口取消
    interfaceCancel: function interfaceCancel() {
      this.apilist.splice(0); //所属于的接口

      this.indeterminate = true;
      this.checkAll = false;
      this.checkAllGroup.splice(0); //选中的项

      this.showModal(false);
    },
    //接口保存
    interfaceOk: function interfaceOk() {
      var checkAllGroup = this.checkAllGroup;
      var str = JSON.stringify(checkAllGroup);
      this.$set(this.currSelectList, this.currCode, JSON.parse(str)); // this.currSelectList[this.currCode]=deepcopy(this.checkAllGroup);//当前所选

      this.showModal(false);
    },
    visibleChange: function visibleChange(b) {
      if (b) {
        this.initInterFace();
      } else {
        this.interfaceCancel();
        this.showModal(false);
      }
    },
    renderContent: function renderContent(h, _ref) {
      var root = _ref.root,
          node = _ref.node,
          data = _ref.data;
      var arr = []; // if (data.category === 1) {
      //   arr.push(h('Button', {
      //     props: Object.assign({}, this.buttonProps, {}),
      //     style: {
      //       marginRight: '8px'
      //     },
      //     on: {
      //       click: () => {
      //         this.selectInterFace(data)
      //       }
      //     }
      //   }, '配置接口'));
      // }

      return h('span', {
        'class': {
          'ivu-tree-title': true
        },
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h('span', [h('Icon', {
        props: {
          type: 'ios-paper-outline'
        },
        style: {
          marginRight: '8px'
        }
      }), h('span', data.title)]), h('span', {
        style: {
          display: 'inline-block',
          float: 'right',
          marginRight: '32px'
        }
      }, arr)]);
    },

    /**
     * 选择配置接口
     * @param data
     */
    selectInterFace: function selectInterFace(data) {
      var _this$apilist;

      //设置当前的code
      this.currCode = data.code;
      console.log(data.code);
      this.checkAllGroup.splice(0); //清空选择项

      this.apilist.splice(0);

      if (!this.currSelectList.hasOwnProperty(this.currCode)) {
        var arr = [];

        for (var i in data.api_codes) {
          if (data.api_codes) {
            arr.push(data.api_codes[i]);
          }
        }

        this.currSelectList[this.currCode] = arr; //当前所选

        for (var _i = 0; _i < data.apilist.length; _i++) {
          var list = data.apilist[_i];

          if (list.checked === 1) {
            this.checkAllGroup.push(list.api_code);
          }
        }
      } else {
        var _this$checkAllGroup2;

        (_this$checkAllGroup2 = this.checkAllGroup).push.apply(_this$checkAllGroup2, _toConsumableArray(this.currSelectList[this.currCode]));
      }

      debugger;
      this.checkAll = this.checkAllGroup.length === data.apilist.length;

      if (this.checkAll) {
        this.indeterminate = false;
      } else {
        this.indeterminate = true;
      }

      (_this$apilist = this.apilist).push.apply(_this$apilist, _toConsumableArray(data.apilist));

      this.showModal(true);
    },
    //选中菜单权限的change
    checkChange: function checkChange(checkData) {// let arr = [];
      // for (let i in checkData) {
      //   let list = checkData[i];
      //   if (list.nodeKey !== 0 && arr.indexOf(list.code)===-1) {
      //     arr.push(list.code)
      //   }
      // }
      // this.$set(this.formModel, 'menu_config', arr)
    },
    initMenu: function initMenu() {
      var _this = this;

      var vm = this;
      this.spinShow = true;
      getgroup_permission({
        group_id: this.admin_id
      }).then(function (res) {
        _this.spinShow = false;

        if (res.result === 0) {
          _this.interConfit = recursiveMenu(res.body);
          console.log('this.interConfit', _this.interConfit);
        } else {}
      });
    }
  },
  mounted: function mounted() {},
  created: function created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData); //this.$set(this.formModel, 'menu_config', arr)
    }

    if (this.personMenu) {
      this.personMenuData.push(this.personMenu);
      this.$set(this.formModel, "parent_id", this.personMenu.personId);
    }

    this.initMenu();
  }
};